// extracted by mini-css-extract-plugin
module.exports = {"canvas":"qrcode_canvas__2BkpR"};